import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container pageheader adminusers" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "StoreAdmin Users")
], -1)
const _hoisted_4 = { class: "search toprow" }
const _hoisted_5 = { class: "p-input-icon-left field-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = { class: "search bottomrow" }
const _hoisted_9 = { class: "p-input-icon-left field-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_11 = { class: "create" }
const _hoisted_12 = { class: "container flex-grow-1 maintable users" }
const _hoisted_13 = { class: "button-container" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, "No users found.", -1)
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "store" }, [
  /*#__PURE__*/_createTextVNode("Store Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "error"
}
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_20 = {
  key: 0,
  class: "error"
}
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_23 = {
  key: 0,
  class: "error"
}
const _hoisted_24 = {
  key: 0,
  class: "field"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("New Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = {
  key: 1,
  class: "field"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "password2" }, [
  /*#__PURE__*/_createTextVNode("Confirm password"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "error"
}
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "role" }, [
  /*#__PURE__*/_createTextVNode("Role"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_32 = {
  key: 0,
  class: "error"
}
const _hoisted_33 = { class: "field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Blocked"),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1)
const _hoisted_35 = { class: "formgrid grid" }
const _hoisted_36 = { class: "field-radiobutton col-12" }
const _hoisted_37 = { for: "status" }
const _hoisted_38 = { class: "field" }
const _hoisted_39 = { for: "email" }
const _hoisted_40 = { class: "field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "New Password*", -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "password2" }, "Confirm password*", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "data" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("strong", null, "Store ID:", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = { class: "data" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("strong", null, "Store Name:", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = { class: "data" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("strong", null, "Name:", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = { class: "data" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = { class: "data" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("strong", null, "Role:", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "data" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("strong", null, "Blocked?:", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = {
  key: 0,
  class: "p-button-rounded btn-blocked"
}
const _hoisted_65 = {
  key: 1,
  label: "No",
  class: "p-button-rounded btn-blocked"
}

import { ref, onBeforeMount, computed } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useConfirm } from "primevue/useconfirm";
import { useToast } from 'primevue/usetoast';
import { useAuth0 } from "@auth0/auth0-vue";
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, sameAs, helpers } from '@vuelidate/validators';
import { useRouter } from 'vue-router';
import { HmacSHA1, enc } from 'crypto-js';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminUsers',
  setup(__props) {

const auth0 = useAuth0();
const stores = ref();
const storeid = ref('');
const role = ref('');
const storestatus = ref('');
const router = useRouter();
const createORedit = ref('');
const features = ref([]);
const exportloading = ref(false);
const loadingDT = ref(false);

onBeforeMount(async () => {
	loadingDT.value = true;
	const auth0 = useAuth0();
	const store = useStore();
	const accessToken = await auth0.getAccessTokenSilently();
	storeid.value = store.state.storeid;
	role.value = store.state.role;
	storestatus.value = store.state.storestatus;

	if (storestatus.value == 'Disable' || role.value != 'SupportAdmin') {
		router.push('/storedisable');
	}

	if (role.value === 'SupportAdmin') {
		await getAllFeatures(accessToken);
		await getAllStores(accessToken);
		await getUserDetails(accessToken);
		await getAllUserRoles(accessToken);
		loadingDT.value = false;
	}
});

const toast = useToast();
const dt = ref();
const users = ref();
const userDialog = ref(false);
const changeUserPasswordDialog = ref(false);
const viewUserDialog = ref(false);
const user = ref({ name: '', email: '', role: '', blocked: '', blockedbool: false, user_id: '', storeid: '', storename: '' });
const selectedUsers = ref();
const filters = ref({ 'global' : { value: null, matchMode: FilterMatchMode.CONTAINS } });
const submitted = ref(false);
const password = ref('');
const password2 = ref('');
const roles = ref([]);
const confirm = useConfirm();

/**
 * Clear filters by initializing
 */
function clearFilter() {
	initFilters();
}

/**
 * Initialize filter
 */
function initFilters() {
	filters.value = {
		'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
	};
}

/**
 * Form validation
 * @param value 
 */
function valid(value: string) {
	const containsUppercase = /[A-Z]/.test(value);
	const containsLowercase = /[a-z]/.test(value);
	const containsNumber = /[0-9]/.test(value);
	const containsSpecial = /[#?!@$%^&*-]/.test(value);
	return containsUppercase && containsLowercase && containsNumber && containsSpecial;
}

/**
 * Preparation of rules for password
 */
const rules = computed(() => ({
	password: { required: helpers.withMessage('Password cannot be empty', required), minLength: helpers.withMessage('Password must be at least 8 characters', minLength(8)), valid: helpers.withMessage('Password must contain uppercase, lowercase, number, special character', valid) },
	password2: { required: helpers.withMessage('Confirm password cannot be empty', required), sameAs: helpers.withMessage('Confirm password must the same as Password', sameAs(password)) },
}));

/**
 * Vuelidate initialization for password
 */
const v$ = useVuelidate(rules, { password, password2 });

/**
 * Preparation of rules for user
 */
const rulesv = computed(() => ({
	storeid: { required: helpers.withMessage('Please select a Store for the user.', required) },
	name: { required: helpers.withMessage('Name cannot be empty.', required) },
	email: { required: helpers.withMessage('Email already exists in the system.  Please use another.', required) },
	role: { required: helpers.withMessage('Role cannot be empty.', required) }
}));

/**
 * Vuelidate initialization for user
 */
const vv$ = useVuelidate(rulesv, user);

/**
 * Prepare data for create new user
 */
function openNew() {
	user.value = { name: '', email: '', role: '', blocked: '', blockedbool: false, user_id: '', storeid: '', storename: '' };
	password.value = '';
	password2.value = '';
	vv$.value.$reset();
	submitted.value = false;
	userDialog.value = true;
	createORedit.value = "Create StoreAdmin User";
}

/**
 * Hide create user dialog
 */
function hideDialog() {
	userDialog.value = false;
	submitted.value = false;
}

/**
 * Hide view dialog
 */
function hideViewDialog() {
	viewUserDialog.value = false;
}

/**
 * Delete user
 */
async function deleteUser() {
	confirm.require({
		message: 'Do you want to delete the current user?',
		header: 'Please confirm Deletion',
		icon: 'pi pi-exclamation-triangle',
		acceptClass: 'p-button-danger',
		accept: async () => {
			const storeid = user.value.storeid;
			const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/" + storeid + "/" + user.value.user_id;
			try {
				const accessToken = await auth0.getAccessTokenSilently();
				const response = await fetch(url, {
					method: 'DELETE',
					headers: {
						Authorization: `Bearer ${accessToken}`,
						'Content-Type': 'application/json'
					},
				});
				//then delete user from array objects
				if (response.status >= 200 && response.status < 300) {
					for (var i = 0; i < users.value.length; i++) {
						if (users.value[i].user_id === user.value.user_id) {
							users.value.splice(i, 1);
							i--;
						}
					}
					toast.add({ severity: 'error', summary: 'Confirmed', detail: 'User has been Deleted', life: 3000 });
				}				
				const data = await response.json();
				if (response.status > 400) {
					throw new Error(JSON.stringify(data.error));
				}
			} catch (e) {
				openErrorModal(e.message);
			}
		},
		reject: () => {
			toast.add({ severity: 'error', summary: 'Rejected', detail: 'User Deletion cancelled.', life: 3000 });
		}
	});
	hideDialog();
}

/**
 * Save and update user
 */
async function saveUser() {
	submitted.value = true;
	const accessToken = await auth0.getAccessTokenSilently();
	if (user.value.email.trim()) {
		if (user.value.user_id) {//update user
			const storeid = user.value.storeid;
			user.value.storename = stores.value[findIndexByStoreId(storeid)].storename;
			users.value[findIndexById(user.value.user_id)] = user.value;
			let userdata = {
				name: user.value.name,
				email: user.value.email,
				role: user.value.role,
				blocked: user.value.blockedbool ? 'true' : 'false',
				password: 'none'
			};
			const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/" + storeid + "/" + user.value.user_id;

			try {
				const response = await fetch(url, {
					method: 'PATCH',
					body: JSON.stringify(userdata),
					headers: {
						Authorization: `Bearer ${accessToken}`,
						'Content-Type': 'application/json'
					},
				});
				if (response.status >= 200 && response.status < 300) {
					toast.add({ severity: 'success', summary: 'Successful', detail: 'User Updated', life: 3000 });
				}
				const data = await response.json();
				if (response.status > 400) {
					throw new Error(JSON.stringify(data.error));
				}
			} catch (e) {
				openErrorModal(e.message);
			}
		}
		else {// new user
			if (!await vv$.value.$validate()) return;

			let userdata = {
				name: user.value.name,
				email: user.value.email,
				role: user.value.role,
				blocked: user.value.blockedbool ? "true" : "false",
				password: password.value
			};
			const accessToken = await auth0.getAccessTokenSilently();
			const storeid = user.value.storeid;
			const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/" + storeid;

			try {
				const response = await fetch(url, {
					method: 'POST',
					body: JSON.stringify(userdata),
					headers: {
						Authorization: `Bearer ${accessToken}`,
						'Content-Type': 'application/json'
					},
				});
				const data = await response.json();
				if (response.status > 400) {
					throw new Error(JSON.stringify(data.error));
				}
				if (data.message.statuscode == 201) {
					user.value.storename = stores.value[findIndexByStoreId(storeid)].storename;
					user.value.blocked = user.value.blockedbool ? "true" : "false";
					users.value.push(user.value);
					user.value.user_id = data.message.result;
					toast.add({ severity: 'success', summary: 'Successful', detail: 'User Created', life: 3000 });
				}
				else if (data.message.statuscode == 409)
					toast.add({ severity: 'error', summary: 'Error', detail: 'The user already exists.', life: 3000 });
				else
					toast.add({ severity: 'error', summary: 'Error', detail: 'User Created failed', life: 3000 });
			} catch (e) {
				openErrorModal(e.message);
			}
			password.value = '';
			password2.value = '';
		}

		userDialog.value = false;
		user.value = { name: '', email: '', role: '', blocked: '', blockedbool: false, user_id: '', storeid: '', storename: '' };
		viewUserDialog.value = false;
	}
}

/**
 * Prepare user data for editing
 * @param prod 
 */
function editUser(prod) {
	user.value = { ...prod };
	userDialog.value = true;
	createORedit.value = "Edit StoreAdmin User";
}

/**
 * Prepare user data for viewing
 * @param prod 
 */
function viewUser(prod) {
	user.value = { ...prod };
	viewUserDialog.value = true;
}

/**
 * Change user password
 * @param prod 
 */
function changeUserPassword(prod) {
	password.value = '';
	password2.value = '';
	v$.value.$reset();
	user.value = { ...prod };
	changeUserPasswordDialog.value = true;
}

/**
 * Save password
 */
async function savePassword() {
	if (!await v$.value.$validate()) return;

	changeUserPasswordDialog.value = false;
	let userdata = {
		password: password.value
	};
	const accessToken = await auth0.getAccessTokenSilently();
	const storeid = user.value.storeid;
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/" + storeid + "/" + user.value.user_id;

	try {

		const response = await fetch(url, {
			method: 'PATCH',
			body: JSON.stringify(userdata),
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		if (response.status >= 200 && response.status < 300) {
			password.value = '';
			password2.value = '';
			toast.add({ severity: 'success', summary: 'Successful', detail: 'Password changed', life: 3000 });
		}
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Immediately sends request to block and unblock user
 * @param prod 
 */
async function blockunblockUser(prod) {
	user.value = { ...prod };

	let blockunblock = "";
	let blockunblockLabel = "";

	if (user.value.blocked == "true") {
		users.value[findIndexById(user.value.user_id)].blocked = "false";
		users.value[findIndexById(user.value.user_id)].blockedbool = false;
		blockunblock = "false";
		blockunblockLabel = "User is unblocked";
	} else {
		blockunblock = "true";
		users.value[findIndexById(user.value.user_id)].blocked = "true";
		users.value[findIndexById(user.value.user_id)].blockedbool = true;
		blockunblockLabel = "User is blocked";
	}

	let userdata = {
		password: 'forblockunblockuser',
		blocked: blockunblock
	};
	const accessToken = await auth0.getAccessTokenSilently();
	const storeid = user.value.storeid;
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/" + storeid + "/" + user.value.user_id;

	try {

		const response = await fetch(url, {
			method: 'PATCH',
			body: JSON.stringify(userdata),
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		if (response.status >= 200 && response.status < 300) {
			toast.add({ severity: 'success', summary: 'Successful', detail: blockunblockLabel, life: 3000 });
		}
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Find index by id
 * @param id 
 */
function findIndexById(id: string) {
	let index = -1;
	for (let i = 0; i < users.value.length; i++) {
		if (users.value[i].user_id === id) {
			index = i;
			break;
		}
	}

	return index;
}

/**
 * Find index by store id
 * @param id 
 */
function findIndexByStoreId(id: string) {
	let index = -1;
	for (let i = 0; i < stores.value.length; i++) {
		if (stores.value[i].id.toLowerCase() === id.toLowerCase()) {
			index = i;
			break;
		}
	}

	return index;
}

/**
 * Get all stores
 * @param accessToken 
 */
const getAllStores = async (accessToken: string) => {
	const Storeurl = process.env.VUE_APP_NODEJS_BASE_URL + "sa/store/all";
	try {
		const response = await fetch(Storeurl, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		stores.value = data.message;
		stores.value.map(async (item) => {
			item.validate = validateCreds(item.connectionid, item.apikey, item.authenticationstring);
		});
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Get all users using store id
 * @param accessToken 
 */
const getUserDetails = async (accessToken: string) => {
	const Userurl = process.env.VUE_APP_NODEJS_BASE_URL + "sa/" + storeid.value; //to get storeadmin users
	try {
		const response = await fetch(Userurl, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		users.value = data.message;
		users.value.map(async (item) => {
			if (findIndexByStoreId(item.storeid) === -1) {
				item.storename = '';
				item.locationname = '';
				item.blockedbool = '';
				return;
			}
			const { storename, locationname } = stores.value[findIndexByStoreId(item.storeid)];
			item.storename = storename;
			item.locationname = locationname;
			item.blockedbool = item.blocked == 'true';
		});
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Get all user roles
 * @param accessToken 
 */
const getAllUserRoles = async (accessToken: string) => {
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/userroles";
	try {
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		roles.value = parseRoleData(data.message);
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Parse fetched roles
 * @param data 
 */
const parseRoleData = (data) => {
	if (role.value === 'SupportAdmin') {
		// Select only StoreAdmin
		const filteredData = data.filter(item => item.userrole === 'StoreAdmin');
		return filteredData.map((item) => ({
			label: item.userrole,
			value: item.userrole,
			availablefeatureids: item.availablefeatureids,
			manageable: item.manageable
		}));
	} else if(role.value === 'StoreAdmin') {
		// Select all userroles excluding SupportAdmin
		const filteredData = data.filter(item => item.userrole !== 'SupportAdmin');
		return filteredData.map((item) => ({
			label: item.userrole,
			value: item.userrole,
			availablefeatureids: item.availablefeatureids,
			manageable: item.manageable
		}));
	}
}

/**
 * Get all features
 * @param accessToken 
 */
const getAllFeatures = async (accessToken: string) => {
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/features";
	try {
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		features.value = data.message;
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Arrangement of column name and its corresponding values, return false if the data is not available
 */
 const convertToCSV = () => {
	if (!(stores.value && features.value && users.value)) {
		return false;
	}

	// store can have empty or multiple users
	// all users have store
	// not all store have users
	let allData = [];
	
	for (let storeCount = 0; storeCount < stores.value.length; storeCount++) {
		let storeData = stores.value[storeCount];
		let matchedUserStore = false;
		for (let usercsvCount = 0; usercsvCount < users.value.length; usercsvCount++) {
			let userData = users.value[usercsvCount];
			if (storeData.id === userData.storeid) {
				matchedUserStore = true;
				allData.push({...userData, ...storeData});
			}
		}
		if (matchedUserStore === false) { // store without user
			allData.push({...storeData});
		}
	}

	const ids = [...new Set([...allData.map((item) => item.id)])];
	for (let usercsvCount = 0 ; usercsvCount < users.value.length; usercsvCount++) {
		if (!ids.includes(users.value[usercsvCount].storeid)) {
			allData.push({...users.value[usercsvCount]}); // user without store
		}
	}

	const header = ['Email', 'Name', 'Role', 'User ID', 'Blocked', 'Store Name', 'Location Name', 'Store ID', 'Connection ID', 'Features', 'API Key', 'Authentication String', 'Store Status', 'Validate'];
	const rows = allData.map((data) => {
        const values = [
			data.email ?? '', // user
			data.name ?? '',
			data.role ?? '',
			data.user_id ?? '',
			isBlocked(data.blocked ?? ''),
			// stores
			data.storename ?? '',
			data.locationname ?? '',
			data.id ?? '',
			data.connectionid ?? '',
			getFeaturesbyFeatureIds(data.managedfeatureids ?? ''),
			data.apikey ?? '',
			data.authenticationstring ?? '',
			data.storestatus ?? '',
			data.validate ?? ''
        ];
        return values.map(value => `"${value}"`).join(',');
    });

	return [header, ...rows].join('\n');
}

/**
 * This will let the browser to download CSV file
 * @param data 
 * @param filename 
 */
const downloadCSV = (data, filename) => {
    const csvContent = 'data:text/csv;charset=utf-8,' + encodeURIComponent(data);
    const link = document.createElement('a');
    
    link.href = csvContent;
    link.download = filename;
    link.click();
}

/**
 * Actual export of all stores, this will ignore the click event if data is still not available
 */
const exportCSV = async () => {
	exportloading.value = true;
	const csvData = convertToCSV();
	if (csvData === false) return;
	downloadCSV(csvData, `${process.env.NODE_ENV}_store_user_data.csv`);
	exportloading.value = false;
}

/**
 * Returns a feature names joined by comma
 * @param featureIds 
 */
const getFeaturesbyFeatureIds = (featureIds) => {	
	const nonmanageablefeatures = features.value.filter((item) => item.manageable == false).map((item) => item.featurename);

	if (featureIds === null) { // return non manageable features
		return nonmanageablefeatures.join(',');
	}

	const arrayFeatureIds = featureIds.split(',');
	const featureNames = arrayFeatureIds.map((id) => {
		const matchfeature = features.value.find((item) => item.featureid == id);
		return matchfeature ? matchfeature.featurename : '';
	});

	return [...new Set([...nonmanageablefeatures, ...featureNames])].join(',');
}

/**
 * Validation of connection id, api key, and authentication string
 * @param connectionid 
 * @param apikey 
 * @param authenticationstring 
 */
 const validateCreds = (connectionid: string, apikey: string, authenticationstring: string) => {
	if (enc.Base64.stringify((HmacSHA1(connectionid, apikey))) === authenticationstring)
		return "Valid";
	else
		return "Invalid";
}

/**
 * Verify the value of blocked parameter
 * @param blocked 
 */
const isBlocked = (blocked) => {
	return blocked === 'false' ? 'No' : blocked === 'true' ? 'Yes' : blocked ?? '';
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: "Search"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-text clear",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (clearFilter()))
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_InputText, {
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: "Search"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-text clear",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (clearFilter()))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            loading: exportloading.value,
            label: "Export User List",
            class: "p-button-rounded btn-export btn-secondary",
            onClick: exportCSV
          }, null, 8, ["loading"]),
          _createVNode(_component_Button, {
            label: "Create User",
            class: "p-button-rounded btn-create btn-primary",
            onClick: openNew
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_DataTable, {
        class: "managerclient-data-table",
        ref_key: "dt",
        ref: dt,
        loading: loadingDT.value,
        value: users.value,
        selection: selectedUsers.value,
        "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => ((selectedUsers).value = $event)),
        dataKey: "id",
        paginator: true,
        rows: 10,
        filters: filters.value,
        stripedRows: "",
        responsiveLayout: "stack",
        breakpoint: "800px",
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [5, 10, 25],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} users"
      }, {
        empty: _withCtx(() => [
          _hoisted_14
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            header: "Name",
            sortable: true,
            class: "name"
          }),
          _createVNode(_component_Column, {
            field: "email",
            header: "Email",
            sortable: true,
            class: "email"
          }),
          _createVNode(_component_Column, {
            field: "storename",
            header: "Store Name",
            sortable: true,
            class: "storename"
          }),
          _createVNode(_component_Column, {
            field: "locationname",
            header: "Location Name",
            sortable: true,
            class: "locationname"
          }),
          _createVNode(_component_Column, {
            field: "blocked",
            class: "status",
            header: "Blocked?",
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.blocked == 'true')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Yes",
                    class: _normalizeClass(["p-button-rounded p-button-danger blocked", slotProps.data.blocked]),
                    onClick: ($event: any) => (blockunblockUser(slotProps.data))
                  }, null, 8, ["class", "onClick"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "No",
                    class: _normalizeClass(["p-button-rounded p-button-success blocked", slotProps.data.blocked]),
                    onClick: ($event: any) => (blockunblockUser(slotProps.data))
                  }, null, 8, ["class", "onClick"]))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "view",
            header: " ",
            sortable: false,
            class: "view"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  label: "View",
                  class: "p-button-rounded btn-view btn-secondary",
                  onClick: ($event: any) => (viewUser(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: "Edit",
                  class: "p-button-rounded btn-edit btn-secondary",
                  onClick: ($event: any) => (editUser(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: "Change Password",
                  class: "p-button-rounded btn-password btn-primary",
                  onClick: ($event: any) => (changeUserPassword(slotProps.data))
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "value", "selection", "filters"]),
      _createVNode(_component_Dialog, {
        visible: userDialog.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((userDialog).value = $event)),
        header: createORedit.value,
        modal: true,
        class: "p-fluid"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: hideDialog
          }),
          (createORedit.value == 'Edit StoreAdmin User')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Delete",
                class: "p-button-rounded btn-save btn-danger",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (deleteUser()))
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            label: "Save",
            class: "p-button-rounded btn-save btn-primary",
            onClick: saveUser
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_Dropdown, {
              modelValue: user.value.storeid,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.storeid) = $event)),
              filter: "",
              options: stores.value,
              optionLabel: "storename",
              optionValue: "id",
              placeholder: "Select a Store",
              class: _normalizeClass({ 'p-invalid': submitted.value && !user.value.storeid })
            }, null, 8, ["modelValue", "options", "class"]),
            (_unref(vv$).storeid.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(vv$).storeid.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: user.value.name,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.value.name) = $event)),
              modelModifiers: { trim: true },
              required: "true",
              class: _normalizeClass({ 'p-invalid': submitted.value && !user.value.name })
            }, null, 8, ["modelValue", "class"]),
            (_unref(vv$).name.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(vv$).name.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_InputText, {
              id: "email",
              modelValue: user.value.email,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((user.value.email) = $event)),
              modelModifiers: { trim: true },
              required: "true",
              class: _normalizeClass({ 'p-invalid': submitted.value && !user.value.email })
            }, null, 8, ["modelValue", "class"]),
            (_unref(vv$).email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(vv$).email.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          (!user.value.user_id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Password, {
                  id: "password",
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((password).value = $event)),
                  modelModifiers: { trim: true },
                  required: "true",
                  class: _normalizeClass({ 'p-invalid': submitted.value && !password.value })
                }, null, 8, ["modelValue", "class"]),
                (_unref(v$).password.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(v$).password.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!user.value.user_id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Password, {
                  id: "password2",
                  modelValue: password2.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((password2).value = $event)),
                  modelModifiers: { trim: true },
                  required: "true",
                  class: _normalizeClass({ 'p-invalid': submitted.value && !password2.value })
                }, null, 8, ["modelValue", "class"]),
                (_unref(v$).password2.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(v$).password2.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_Dropdown, {
              id: "role",
              modelValue: user.value.role,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((user.value.role) = $event)),
              options: roles.value,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Select a Role",
              class: _normalizeClass({ 'p-invalid': submitted.value && !user.value.role })
            }, null, 8, ["modelValue", "options", "class"]),
            (_unref(vv$).role.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(vv$).role.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_InputSwitch, {
                  modelValue: user.value.blockedbool,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((user.value.blockedbool) = $event)),
                  style: {"border-radius":"1.5em"}
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_37, _toDisplayString(user.value.blockedbool ? 'Yes' : 'No'), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "header"]),
      _createVNode(_component_Dialog, {
        visible: changeUserPasswordDialog.value,
        "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((changeUserPasswordDialog).value = $event)),
        header: "Change password",
        modal: true,
        class: "p-fluid"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (changeUserPasswordDialog.value = false))
          }),
          _createVNode(_component_Button, {
            label: "Save",
            class: "p-button-rounded btn-save btn-primary",
            onClick: savePassword
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("label", _hoisted_39, _toDisplayString(user.value.email), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(_component_Password, {
              id: "password",
              modelValue: password.value,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((password).value = $event)),
              modelModifiers: { trim: true },
              required: "true",
              class: _normalizeClass({ 'p-invalid': !password.value })
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).password.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_unref(v$).password.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createVNode(_component_Password, {
              id: "password2",
              modelValue: password2.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((password2).value = $event)),
              modelModifiers: { trim: true },
              required: "true",
              class: _normalizeClass({ 'p-invalid': !password2.value })
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).password2.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_unref(v$).password2.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: viewUserDialog.value,
        "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((viewUserDialog).value = $event)),
        header: "View StoreAdmin User Details",
        modal: true,
        class: "p-fluid"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (hideViewDialog()))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("p", null, [
              _hoisted_47,
              _hoisted_48,
              _createElementVNode("span", null, _toDisplayString(user.value.storeid), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("p", null, [
              _hoisted_50,
              _hoisted_51,
              _createElementVNode("span", null, _toDisplayString(user.value.storename), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("p", null, [
              _hoisted_53,
              _hoisted_54,
              _createElementVNode("span", null, _toDisplayString(user.value.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("p", null, [
              _hoisted_56,
              _hoisted_57,
              _createElementVNode("span", null, _toDisplayString(user.value.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("p", null, [
              _hoisted_59,
              _hoisted_60,
              _createElementVNode("span", null, _toDisplayString(user.value.role), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("p", null, [
              _hoisted_62,
              _hoisted_63,
              (user.value.blocked == 'true')
                ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Yes"))
                : (_openBlock(), _createElementBlock("span", _hoisted_65, "No"))
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})